import React, {useEffect} from 'react';
import {Root, Routes, useSiteData} from 'react-static';
import {Helmet} from 'react-helmet';
import {Router} from '@reach/router';
import axios from 'axios';
import queryString from 'query-string';

import {PhaseProvider, usePhaseDispatch} from './funnel-schedule/phase-context';
import {UserProvider, useUserState, useUserDispatch} from './contexts/user';
import OptinModal from 'components/OptinModal';
import {ModalProvider} from 'contexts/modal';
import 'styles/app.scss';

//Due to a limitation of dotenv we must use three seperate statements
const {SCHEDULE_URL} = process.env;
const {SF_API_URL} = process.env;
const {SITE_ID} = process.env;

function AppWrapper({children}) {
  const phaseDispatch = usePhaseDispatch();
  const userDispatch = useUserDispatch();
  const {email, registrationId} = useUserState();
  useEffect(() => {
    axios.get(SCHEDULE_URL).then(({data}) => {
      if (typeof window !== 'undefined') {
        const qs = queryString.parse(window.location.search);
        if (qs.phase) {
          data.default = {...data.default, phase: qs.phase};
        }
      }
      return phaseDispatch({
        type: 'SET_PHASE',
        payload: data
      });
    });
  }, []);
  useEffect(() => {
    (registrationId || email) &&
      axios
        .get(`${SF_API_URL}/site/${SITE_ID}/state/`, {
          params: registrationId ? {registrationId} : {email}
        })
        .then(({data}) => {
          const {firedEvents = []} = data.webinar || {};
          phaseDispatch({
            type: 'SET_PHASE',
            payload: data
          });
          firedEvents.map((e) => userDispatch({type: 'ADD_EVENT', payload: e}));
        });
  }, [registrationId, email]);
  return children;
}

const App = () => {
  const {phaseData} = useSiteData();
  return (
    <Root>
      <Helmet>
        <meta charSet="utf-8" />
      </Helmet>
      <UserProvider>
        <PhaseProvider value={phaseData}>
          <ModalProvider>
            <AppWrapper>
              <Router className="frn-content d-flex align-items-stretch flex-column">
                <Routes default />
              </Router>
            </AppWrapper>
          </ModalProvider>
        </PhaseProvider>
      </UserProvider>
    </Root>
  );
};

export default App;
